import { storage } from '../../services/StorageService';

/**
 * Settings → Interface "Overhead names" (UserPrefs ui.overheadNames, plan 15
 * §2.3), read by the overhead layout every solve. One cached value kept fresh
 * by one prefs subscription — no localStorage parse per frame.
 *
 * - `all`: every name, decluttered, never faded;
 * - `smart` (default): target, bosses, self and party always; everyone else
 *   when hovered or when nothing overlaps them, and fading with distance;
 * - `target`: names only for the target, the hovered entity, bosses and self.
 */
export type OverheadNamesMode = 'all' | 'smart' | 'target';
export const OVERHEAD_NAMES_MODES: readonly OverheadNamesMode[] = ['all', 'smart', 'target'];

let cached: OverheadNamesMode | null = null;
let subscribed = false;

export function getOverheadNamesMode(): OverheadNamesMode {
  if (cached === null) {
    try {
      cached = storage.loadUserPrefs().ui.overheadNames;
      if (!subscribed) {
        subscribed = true;
        storage.subscribeUserPrefs((p) => { cached = p.ui.overheadNames; });
      }
    } catch {
      cached = 'smart'; // storage unavailable (tests, private window)
    }
  }
  return cached;
}

export function setOverheadNamesMode(mode: OverheadNamesMode): void {
  const cur = storage.loadUserPrefs();
  storage.saveUserPrefs({ ...cur, ui: { ...cur.ui, overheadNames: mode } });
  cached = mode;
}

/** Test hook. */
export function __resetOverheadNamesModeForTesting(mode: OverheadNamesMode | null = null): void {
  cached = mode;
}
